import { useEffect } from "react";
import { useCoastguard } from "@cofano/coastguard2-frontend-client";
import { CircularProgress, Paper } from "@mui/material";
import { useStoreActions } from "ezStore";
import { useNavigate } from "react-router-dom";

export default function Logout() {

	const navigate = useNavigate();

	const { instance: { isAuthenticated, logout } } = useCoastguard();

	const { logout: logoutSession } = useStoreActions(store => store.session);

	const logOut = () => {
		logout().then(() => {
			logoutSession();
			navigate("/");
		}).catch(() => {
			console.error("Error occurred while logging out");
		});
	};

	useEffect(() => {
		if (isAuthenticated) {
			logOut();
		}
	}, [ isAuthenticated ]);

	return (
		<Paper
			square
			sx={{
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				width: "100%",
				height: "100%",
			}}
		>
			<CircularProgress size={30} />
		</Paper>
	);
}
